import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MenuComponent } from '../../layout/menu/menu.component';
import { RodapeComponent } from '../../layout/rodape/rodape.component';

@Component({
  selector: 'app-hosting',
  imports: [
    MenuComponent,
    RodapeComponent
  ],
  templateUrl: './hosting.component.html',
  styleUrl: './hosting.component.css'
})
export class HostingComponent implements OnInit {
  constructor(private title: Title, private meta: Meta) {}

  ngOnInit() {
    this.title.setTitle('Hospedagem Web - Fluxodigital - Web | Infra');
    this.meta.updateTag({ 
      name: 'description', 
      content: 'Hospedagem de sites de alta performance em Angola com a qualidade Fluxodigital.' 
    });

    // Open Graph
    this.meta.updateTag({ property: 'og:title', content: 'Hospedagem Web - Fluxodigital - Web | Infra' });
    this.meta.updateTag({ property: 'og:description', content: 'Infraestrutura robusta em Angola para o seu negócio digital.' });
  }
}
